import { render, staticRenderFns } from "./teamChangeLearner.vue?vue&type=template&id=6380ac3a&lang=html&"
import script from "./teamChangeLearner.vue?vue&type=script&lang=ts&"
export * from "./teamChangeLearner.vue?vue&type=script&lang=ts&"
import style0 from "./teamChangeLearner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports